import { toValue as e, isClient as _, toRefs as P, noop as S, isObject as V, tryOnScopeDispose as X } from "./index323.js";
import { ref as C, computed as L, watch as Y } from "vue";
const B = _ ? window : void 0;
function j(i) {
  var n;
  const r = e(i);
  return (n = r?.$el) != null ? n : r;
}
function D(...i) {
  let n, r, a, h;
  if (typeof i[0] == "string" || Array.isArray(i[0]) ? ([r, a, h] = i, n = B) : [n, r, a, h] = i, !n)
    return S;
  Array.isArray(r) || (r = [r]), Array.isArray(a) || (a = [a]);
  const m = [], x = () => {
    m.forEach((o) => o()), m.length = 0;
  }, R = (o, c, u, p) => (o.addEventListener(c, u, p), () => o.removeEventListener(c, u, p)), b = Y(
    () => [j(n), e(h)],
    ([o, c]) => {
      if (x(), !o)
        return;
      const u = V(c) ? { ...c } : c;
      m.push(
        ...r.flatMap((p) => a.map((E) => R(o, p, E, u)))
      );
    },
    { immediate: !0, flush: "post" }
  ), y = () => {
    b(), x();
  };
  return X(y), y;
}
function z(i, n = {}) {
  var r, a;
  const {
    pointerTypes: h,
    preventDefault: m,
    stopPropagation: x,
    exact: R,
    onMove: b,
    onEnd: y,
    onStart: o,
    initialValue: c,
    axis: u = "both",
    draggingElement: p = B,
    containerElement: E,
    handle: T = i,
    buttons: W = [0]
  } = n, f = C(
    (r = e(c)) != null ? r : { x: 0, y: 0 }
  ), d = C(), w = (t) => h ? h.includes(t.pointerType) : !0, A = (t) => {
    e(m) && t.preventDefault(), e(x) && t.stopPropagation();
  }, $ = (t) => {
    var v;
    if (!e(W).includes(t.button) || e(n.disabled) || !w(t) || e(R) && t.target !== e(i))
      return;
    const l = e(E), g = (v = l?.getBoundingClientRect) == null ? void 0 : v.call(l), s = e(i).getBoundingClientRect(), M = {
      x: t.clientX - (l ? s.left - g.left + l.scrollLeft : s.left),
      y: t.clientY - (l ? s.top - g.top + l.scrollTop : s.top)
    };
    o?.(M, t) !== !1 && (d.value = M, A(t));
  }, H = (t) => {
    if (e(n.disabled) || !w(t) || !d.value)
      return;
    const v = e(E), l = e(i).getBoundingClientRect();
    let { x: g, y: s } = f.value;
    (u === "x" || u === "both") && (g = t.clientX - d.value.x, v && (g = Math.min(Math.max(0, g), v.scrollWidth - l.width))), (u === "y" || u === "both") && (s = t.clientY - d.value.y, v && (s = Math.min(Math.max(0, s), v.scrollHeight - l.height))), f.value = {
      x: g,
      y: s
    }, b?.(f.value, t), A(t);
  }, O = (t) => {
    e(n.disabled) || !w(t) || d.value && (d.value = void 0, y?.(f.value, t), A(t));
  };
  if (_) {
    const t = { capture: (a = n.capture) != null ? a : !0 };
    D(T, "pointerdown", $, t), D(p, "pointermove", H, t), D(p, "pointerup", O, t);
  }
  return {
    ...P(f),
    position: f,
    isDragging: L(() => !!d.value),
    style: L(
      () => `left:${f.value.x}px;top:${f.value.y}px;`
    )
  };
}
export {
  B as defaultWindow,
  _ as isClient,
  V as isObject,
  S as noop,
  P as toRefs,
  e as toValue,
  X as tryOnScopeDispose,
  j as unrefElement,
  z as useDraggable,
  D as useEventListener
};
